import { AfterViewInit, Component, ElementRef, HostListener, Injector, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { NavigationLink } from 'src/app/services/navigation-links/navigation-link';

@Component({
  selector: 'app-navigation-links',
  templateUrl: './navigation-links.component.html',
  styleUrls: ['./navigation-links.component.scss']
})
export class NavigationLinksComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit
{

  @ViewChild("sidenav") sidenav!: MatSidenav;
  @ViewChild("headerTop") headerTop!: ElementRef;

  disabled: boolean = false;

  loading = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];
  headerOnTop: boolean = false;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;
  filter: any;

  navigationLink?: NavigationLink;
  navigationLinks?: NavigationLink[];
  navigationLinksFiltered?: NavigationLink[];
  navigationLinks$!: Observable<NavigationLink[]>;
  navigationLinksSubs!: Subscription;

  loadingMessage!: string;

  showAmendmentToggle: boolean = false;
  private resizeTimer: any;
  //////

  constructor(
    protected override injector: Injector
  )
  {
    super(injector);
  }

  ngAfterViewInit(): void
  {
    this.setHeights();
  }

  ngOnChanges(changes: SimpleChanges): void
  {
  }

  override ngOnDestroy(): void
  {
    this.navigationLinksSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  ngOnInit()
  {
    this.moduleTitle = "Links Catalog";
    this.checkPrivileges();
    this.loadNavigationLinks();
  }

  loadNavigationLinks()
  {
    this.navigationLinks$ = this.store.select(state => state.NavigationLinks.data);
    this.navigationLinksSubs = this.navigationLinks$.subscribe(data =>
    {
      if (data?.length)
      {
        this.navigationLinks = data;
        if (this.navigationLink)
        {
          const navigationLink = this.navigationLinks.find(x => x.id == this.navigationLink?.id);
          this.navigationLink = navigationLink;
        }
      }
    });
  }

  rowSelected(e?: NavigationLink)
  {
    this.navigationLink = e;
  }

  clear()
  {
    this.errorMessages = [];
  }

  create() { }
  release() { }

  async setEditing(value: boolean)
  {
  }

  @HostListener("window:resize")
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 768) {
        this.isExpanded = false;
      }
    }, 200);
  }

  @HostListener("window:scroll")
  isHeaderOnTop()
  {
    let elemRec;
    if (this.headerTop?.nativeElement !== undefined)
    {
      elemRec = this.headerTop.nativeElement.getBoundingClientRect();
      const docViewTop = window.screenTop;
      const elemTop = elemRec.top;
      if (elemTop <= docViewTop)
      {
        this.headerOnTop = true;
      } else
      {
        this.headerOnTop = false;
      }
      // this.tableWidth = this.scheduleTable.nativeElement.offsetWidth + 'px';
    } else
    {
      this.headerOnTop = false;
    }
  }

  //////
  changedFilter() { }
  clearFilter() { }
  selectedFilter() { }
  createDisabled() { }
  editDisabled() { }
  action() { }

  applyFilter(e: any)
  {
    if (!e)
      this.valueFilter = '';
    this.filter = e;
  }

  checkPrivileges() { }
  duplicate() { }
  requestAmendment() { }

  setLoading(e: any, origin: any)
  {
    if (!e)
    {
      setTimeout(() =>
      {
        this.showLoading(e, origin);
      }, 2000);
    }
    else { this.showLoading(e, origin); }
  }

  showLoading(e: boolean, origin: any)
  {
    setTimeout(() =>
    {
      switch (origin)
      {
        case LoadingOrigin.Side:
          this.loadingSide = e as boolean;
          break;
        case LoadingOrigin.Buttons:
          this.loadingButtons = e as boolean;
          break;
        case LoadingOrigin.Main:
          this.loadingMain = e as boolean;
          break;
      }
      // console.log('m: ' + this.loadingMain + '   b: ' + this.loadingButtons + '   s: ' + this.loadingSide);
      this.loading = this.loadingMain || this.loadingButtons || this.loadingSide;
    }, 100);
  }

  loadingSide = false;
  loadingButtons = false;
  loadingMain = false;
  loadingOrigin = LoadingOrigin;
}

enum LoadingOrigin
{
  Side = 1, Buttons = 2, Main = 3
}
